export enum QuestionCategoryMutation {
  SET_QUESTION_CATEGORIES = "SET_QUESTION_CATEGORIES",
}
